import { createReducer, Dictionary } from '@reduxjs/toolkit';

import { reinstateRemovedStudent, removeCourseStudent } from '../courses/actions';
import { setCourseUserProfiles } from './actions';
import { CourseUserProfile } from './types';

interface UserProfiles {
  byId: Dictionary<CourseUserProfile>;
}

const initialState: UserProfiles = {
  byId: {},
};

const userProfilesReducer = createReducer(initialState, (builder) => {
  builder.addCase(setCourseUserProfiles, (state, action) => {
    const { userProfiles } = action.payload;

    for (const avatarId in userProfiles) {
      const userProfile = userProfiles[avatarId]!;

      const existingUserProfile = state.byId[avatarId];

      const transformedUserProfile: CourseUserProfile = {
        avatarId,
        avatarUrl: userProfile.avatarUrl,
        name: userProfile.name,
        emailId: userProfile.emailId || existingUserProfile?.emailId || '',
        courseUserDetails: existingUserProfile?.courseUserDetails ?? {},
        lastFetchedAt: userProfile.lastFetchedAt,
      };

      for (const courseId in userProfile.courseUserDetails) {
        const userDetails = userProfile.courseUserDetails[courseId];
        transformedUserProfile.courseUserDetails[courseId] = userDetails;
      }

      state.byId[avatarId] = transformedUserProfile;
    }
  });

  builder.addCase(removeCourseStudent.success, (state, action) => {
    const { avatarId, courseId } = action.payload;

    const courseUserProfile = state.byId[avatarId];
    if (!courseUserProfile) return;

    state.byId[avatarId] = {
      ...courseUserProfile,
      courseUserDetails: {
        ...courseUserProfile.courseUserDetails,
        [courseId]: {
          ...courseUserProfile.courseUserDetails[courseId],
          isRemovedMember: true,
        },
      },
    };
  });

  builder.addCase(reinstateRemovedStudent.success, (state, action) => {
    const { avatarId, courseId } = action.payload;

    const courseUserProfile = state.byId[avatarId];
    if (!courseUserProfile) return;

    state.byId[avatarId] = {
      ...courseUserProfile,
      courseUserDetails: {
        ...courseUserProfile.courseUserDetails,
        [courseId]: {
          ...courseUserProfile.courseUserDetails[courseId],
          isRemovedMember: false,
        },
      },
    };
  });
});

export default userProfilesReducer;
